// extracted by mini-css-extract-plugin
module.exports = {"form":"login-form_form__3E1FS","inputContainerGroup":"login-form_inputContainerGroup__29-ur","logoContainer":"login-form_logoContainer__SsmzH"};